import { render, staticRenderFns } from "./ManageAllVessels.vue?vue&type=template&id=1bfa352d&scoped=true"
import script from "./ManageAllVessels.vue?vue&type=script&lang=js"
export * from "./ManageAllVessels.vue?vue&type=script&lang=js"
import style0 from "./ManageAllVessels.vue?vue&type=style&index=0&id=1bfa352d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa352d",
  null
  
)

export default component.exports